import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import { Panel } from 'mk2/components/Panel';
import React from 'react';
import styles from './ClearableInput.mscss';

export interface OwnProps {
    className?: string;
    hasValue?: boolean;
    icon?: React.ReactNode;
    clearIcon?: React.ReactNode;
    outlined?: boolean;
    onClear?(event: React.MouseEvent<HTMLAnchorElement>);
}

type Props = OwnProps;

export const ClearableInput: React.FunctionComponent<Props> = ({
    className,
    hasValue = false,
    icon,
    children,
    onClear,
    clearIcon,
    outlined = false,
}) => (
    <Panel className={cx(styles.ClearableInput, className, outlined && styles['ClearableInput--outlined'])}>
        {icon && <div className={styles.ClearableInput__icon}>{icon}</div>}
        <div className={styles.ClearableInput__content}>{children}</div>
        {hasValue && (
            <a data-google-interstitial="false" className={styles.ClearableInput__clear} onClick={onClear}>
                {clearIcon ? clearIcon : <FontAwesomeIcon icon={faTimes} />}
            </a>
        )}
    </Panel>
);

ClearableInput.displayName = 'ClearableInput';
